import {createGlobalSlice} from "@/data/create_global_slice.js";

export const {merge, reducer, remove, replace, update} = createGlobalSlice("User");
